import {
  doc,
  collection,
  getDocs,
  addDoc,
  deleteDoc,
  query,
  orderBy
} from 'firebase/firestore'
import { DB } from '../../configs/firebase'
import { formatDateForDB, formatDate } from '../../utils/date'

export default {
  namespaced: true,
  state: {
    messages: []
  },
  getters: {
    ALL: (state) => state.messages
  },
  mutations: {
    SET_MESSAGES(state, payload) {
      state.messages = payload
    },
    ADD_MESSAGE(state, payload) {
      state.messages.push(payload)
    },
    DELETE_MESSAGE(state, id) {
      const index = state.messages.findIndex((message) => message.id === id)
      state.messages.splice(index, 1)
    }
  },
  actions: {
    async GET_ALL({ commit }) {
      const q = query(
        collection(DB, 'contact_us'),
        orderBy('createdAt', 'desc')
      )
      const results = await getDocs(q)
      const messages = results.docs.map((doc) => {
        const data = doc.data()
        data.id = doc.id
        data.createdAt = Number(formatDate(data.createdAt, 'x'))
        return data
      })
      commit('SET_MESSAGES', messages)
      return true
    },
    async SEND({ commit }, { name, email, body }) {
      try {
        const docRef = collection(DB, 'contact_us')
        const newMessage = {
          name,
          email,
          body,
          createdAt: formatDateForDB(new Date())
        }
        const message = await addDoc(docRef, newMessage)
        commit('ADD_MESSAGE', { id: message.id, ...newMessage })
        return true
      } catch (err) {
        console.log('err while sending message: ', err)
        throw err
      }
    },
    async DELETE({ commit }, { id }) {
      try {
        const docRef = doc(DB, 'contact_us', id)
        await deleteDoc(docRef)
        commit('DELETE_MESSAGE', id)
        return true
      } catch (err) {
        console.log('err while sending message: ', err)
        throw err
      }
    }
  }
}
